import { generateClient } from 'aws-amplify/api';

const client = generateClient();
const iamClient = generateClient({ authMode: 'iam' });

export { client, iamClient };
